export default "__VITE_ASSET__da1a005f__"